module.exports = __webpack_public_path__ + "img/bt.3cfe1440.png";